import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2 } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// This is a copy of FinancialsTab.tsx but with Wonka-specific trade spend data for Food & Beverage industry
// Card Revenue Data (Monthly Revenue in Millions, Jan-22 to Mar-25)
const cardRevenueData = [{
  month: 'Jan-22',
  revenue: 3.2
}, {
  month: 'Feb-22',
  revenue: 3.3
}, {
  month: 'Mar-22',
  revenue: 3.4
}, {
  month: 'Apr-22',
  revenue: 3.3
}, {
  month: 'May-22',
  revenue: 3.5
}, {
  month: 'Jun-22',
  revenue: 3.5
}, {
  month: 'Jul-22',
  revenue: 3.6
}, {
  month: 'Aug-22',
  revenue: 3.6
}, {
  month: 'Sep-22',
  revenue: 3.7
}, {
  month: 'Oct-22',
  revenue: 3.7
}, {
  month: 'Nov-22',
  revenue: 3.8
}, {
  month: 'Dec-22',
  revenue: 3.8
}, {
  month: 'Jan-23',
  revenue: 3.5
}, {
  month: 'Feb-23',
  revenue: 3.6
}, {
  month: 'Mar-23',
  revenue: 3.7
}, {
  month: 'Apr-23',
  revenue: 3.6
}, {
  month: 'May-23',
  revenue: 3.7
}, {
  month: 'Jun-23',
  revenue: 3.8
}, {
  month: 'Jul-23',
  revenue: 3.9
}, {
  month: 'Aug-23',
  revenue: 3.8
}, {
  month: 'Sep-23',
  revenue: 4.0
}, {
  month: 'Oct-23',
  revenue: 4.0
}, {
  month: 'Nov-23',
  revenue: 4.1
}, {
  month: 'Dec-23',
  revenue: 4.1
}, {
  month: 'Jan-24',
  revenue: 3.8
}, {
  month: 'Feb-24',
  revenue: 3.8
}, {
  month: 'Mar-24',
  revenue: 4.0
}, {
  month: 'Apr-24',
  revenue: 3.9
}, {
  month: 'May-24',
  revenue: 4.0
}, {
  month: 'Jun-24',
  revenue: 4.1
}, {
  month: 'Jul-24',
  revenue: 4.2
}, {
  month: 'Aug-24',
  revenue: 4.1
}, {
  month: 'Sep-24',
  revenue: 4.3
}, {
  month: 'Oct-24',
  revenue: 4.3
}, {
  month: 'Nov-24',
  revenue: 4.4
}, {
  month: 'Dec-24',
  revenue: 4.4
}, {
  month: 'Jan-25',
  revenue: 4.1
}, {
  month: 'Feb-25',
  revenue: 4.2
}, {
  month: 'Mar-25',
  revenue: 4.3
}];
const dbtData = [{
  month: 'Oct-24',
  dbt: 7,
  industry: 12,
  yourAR: 3
}, {
  month: 'Nov-24',
  dbt: 6,
  industry: 11,
  yourAR: 2
}, {
  month: 'Dec-24',
  dbt: 5,
  industry: 10,
  yourAR: 2
}, {
  month: 'Jan-25',
  dbt: 10,
  industry: 10,
  yourAR: 4
}, {
  month: 'Feb-25',
  dbt: 8,
  industry: 9,
  yourAR: 3
}, {
  month: 'Mar-25',
  dbt: 6,
  industry: 9,
  yourAR: 2
}, {
  month: 'Apr-25',
  dbt: 9,
  industry: 9,
  yourAR: 3
}, {
  month: 'May-25',
  dbt: 8,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jun-25',
  dbt: 7,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jul-25',
  dbt: 7,
  industry: 9,
  yourAR: 3
}, {
  month: 'Aug-25',
  dbt: 11,
  industry: 10,
  yourAR: 4
}];
const paidData = [{
  name: 'Current',
  value: 28500000
}, {
  name: '1-30',
  value: 1200000
}, {
  name: '31-60',
  value: 85000
}, {
  name: '61-90',
  value: 12000
}, {
  name: '91+',
  value: 3000
}];
const outstandingData = [{
  name: 'Current',
  value: 1650000
}, {
  name: '1-30',
  value: 180000
}, {
  name: '31-60',
  value: 15000
}, {
  name: '61-90',
  value: 5000
}, {
  name: '91+',
  value: 0
}];
// Trade Spend by Industry Data - WONKA SPECIFIC (Food & Beverage)
const tradeSpendData = [{
  name: 'Food & Beverage Manufacturing',
  value: 850000,
  color: '#4f46e5',
  percentage: 46
}, {
  name: 'Retail & Distribution',
  value: 620000,
  color: '#10b981',
  percentage: 33
}, {
  name: 'Packaging & Supplies',
  value: 380000,
  color: '#9ca3af',
  percentage: 21
}];
// Payment Aging by Industry Data - WONKA SPECIFIC
const paymentAgingData = [{
  industry: 'Food & Beverage Manufacturing',
  total: '$850K',
  trades: 18,
  current: 94,
  days1to30: 5,
  days31to60: 1,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Retail & Distribution',
  total: '$620K',
  trades: 42,
  current: 96,
  days1to30: 4,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Packaging & Supplies',
  total: '$380K',
  trades: 28,
  current: 93,
  days1to30: 6,
  days31to60: 1,
  days61to90: 0,
  days91plus: 0
}];
export function WonkaFinancialsTab() {
  return <div className="space-y-6 mt-6" data-id="element-3723">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-3724">
        <div className="flex justify-between items-start mb-8" data-id="element-3725">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3726">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-3727">
            <Upload className="w-4 h-4" data-id="element-3728" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-3729">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-3730">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-3731">
            <div className="flex items-center gap-6" data-id="element-3732">
              <div className="flex items-center gap-3" data-id="element-3733">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-3734">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-3735" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-3736">
                  Wonka-Financial-Statement-2025-Q1
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-3737"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-3738">
                <Calendar className="w-4 h-4" data-id="element-3739" />
                <span className="font-medium" data-id="element-3740">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-3741">
                <Clock className="w-4 h-4" data-id="element-3742" />
                <span className="font-medium" data-id="element-3743">Q1</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-3744">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-3745">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-3746" />
                <span className="text-green-700 font-medium text-sm" data-id="element-3747">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-3748">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-3749" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-3750">
          {/* Liquidity Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3751">
            <div className="flex items-center gap-2 mb-4" data-id="element-3752">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-3753">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-3754" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3755">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-3756">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3757">
                <span className="text-xs text-gray-600" data-id="element-3758">Current Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3759">2.85</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3760">
                <span className="text-xs text-gray-600" data-id="element-3761">Quick Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3762">2.41</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3763">
                <span className="text-xs text-gray-600" data-id="element-3764">Working Capital</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3765">$8.6M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3766">
            <div className="flex items-center gap-2 mb-4" data-id="element-3767">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-3768">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-3769" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3770">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-3771">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3772">
                <span className="text-xs text-gray-600" data-id="element-3773">Op. Cash Flow</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3774">1.52</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3775">
                <span className="text-xs text-gray-600" data-id="element-3776">Free Cash Flow</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3777">$2.4M</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3778">
                <span className="text-xs text-gray-600" data-id="element-3779">CF Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3780">12.35</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3781">
            <div className="flex items-center gap-2 mb-4" data-id="element-3782">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-3783">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-3784" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3785">Profitability</h3>
            </div>
            <div className="space-y-3" data-id="element-3786">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3787">
                <span className="text-xs text-gray-600" data-id="element-3788">Net Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3789">0.08</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3790">
                <span className="text-xs text-gray-600" data-id="element-3791">ROE</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3792">0.18</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3793">
                <span className="text-xs text-gray-600" data-id="element-3794">Gross Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3795">0.32</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3796">
            <div className="flex items-center gap-2 mb-4" data-id="element-3797">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-3798">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-3799" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3800">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-3801">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3802">
                <span className="text-xs text-gray-600" data-id="element-3803">Inv. Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3804">8.50</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3805">
                <span className="text-xs text-gray-600" data-id="element-3806">AR Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3807">10.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3808">
                <span className="text-xs text-gray-600" data-id="element-3809">DSO</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3810">35.78</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3811">
            <div className="flex items-center gap-2 mb-4" data-id="element-3812">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-3813">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-3814" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3815">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-3816">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3817">
                <span className="text-xs text-gray-600" data-id="element-3818">Debt-to-Equity</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3819">0.65</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3820">
                <span className="text-xs text-gray-600" data-id="element-3821">Z-Score</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3822">3.42</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3823">
                <span className="text-xs text-gray-600" data-id="element-3824">Int. Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3825">18.50</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3826">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3827">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - More compact layout */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-3828">
          <div className="flex flex-col" data-id="element-3829">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3830">
              $5.1M
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3831">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3832"></div>
          <div className="flex flex-col" data-id="element-3833">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3834">
              6.8K
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3835">
              Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3836"></div>
          <div className="flex flex-col" data-id="element-3837">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3838">
              $750
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3839">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3840"></div>
          <div className="flex flex-col" data-id="element-3841">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3842">
              0 - 28
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3843">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3844"></div>
          <div className="flex flex-col" data-id="element-3845">
            <span className="text-2xl font-bold text-green-600 mb-0.5" data-id="element-3846">
              +6%
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3847">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart */}
        <div className="h-80 w-full" data-id="element-3848">
          <ResponsiveContainer width="100%" height="100%" data-id="element-3849">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-3850">
              <defs data-id="element-3851">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-3852">
                  <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} data-id="element-3853" />
                  <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} data-id="element-3854" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3855" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-3856" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 8]} ticks={[0, 2, 4, 6, 8]} tickFormatter={value => `$${value}M`} data-id="element-3857" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(1)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-3858" />
              <Area type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#4f46e5',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-3859" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-3860">
        {/* Trade Credit */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 lg:col-span-2" data-id="element-3861">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3862">Trade Credit</h2>
          <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-3863">
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3864">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3865">
                $50K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3866">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3867">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3868">3</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3869">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3870">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3871">
                142
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3872">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3873">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3874">
                $1.85M
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3875">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3876">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3877">
                $275K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3878">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3879">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3880">
                $13.0K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3881">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3882">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3883">
                $12.5K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3884">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3885">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3886">
                0.7%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3887">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-3888">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3889">$0</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3890">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-3891">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3892">0%</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3893">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col lg:col-span-3" data-id="element-3894">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-3" data-id="element-3895">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-3896">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-xs bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-3897">
              <div className="flex items-center gap-2" data-id="element-3898">
                <div className="w-5 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-3899"></div>
                <span className="font-medium text-gray-600" data-id="element-3900">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-3901">
                <div className="w-5 h-0.5 bg-gray-900" data-id="element-3902"></div>
                <span className="font-medium text-gray-900" data-id="element-3903">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-3904">
                <div className="w-5 h-0.5 bg-indigo-600" data-id="element-3905"></div>
                <span className="font-medium text-indigo-600" data-id="element-3906">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-6 max-w-md leading-relaxed" data-id="element-3907">
            Compare how they pay the industry, how they pay their vendors
            generally, and how they pay you.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-3908">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3909">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-3910">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3911" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-3912" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 15]} ticks={[0, 5, 10, 15]} data-id="element-3913" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-3914" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-3915" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-3916" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#4f46e5" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#4f46e5'
              }} data-id="element-3917" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging - keeping rest of component identical to FinancialsTab */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-3918">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-3919">
          <div data-id="element-3920">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3921">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-3922">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-3923">
                Total Trade Lines: 142
              </span>
              <span className="text-gray-500" data-id="element-3924">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-3925">
          <table className="w-full text-left border-collapse" data-id="element-3926">
            <thead data-id="element-3927">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-3928">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-3929">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3930">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3931">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3932">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3933">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3934">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-3935">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3936">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3937">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3938">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3939">
                  $28,500,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3940">
                  $1,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3941">
                  $85,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3942">
                  $12,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3943">
                  $3,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-3944">
                  $29,800,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3945">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3946">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3947">
                  $1,650,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3948">
                  $180,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3949">
                  $15,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3950">
                  $5,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3951">
                  $0
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-3952">
                  $1,850,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3953">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3954">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3955">
                  112
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3956">
                  22
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3957">
                  5
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3958">
                  2
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3959">
                  1
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-3960">
                  142
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3961">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-3962">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-3963">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-3964"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-3965">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3966">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-3967">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3968" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-3969" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-3970" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-3971" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-3973" />;
                }} data-id="element-3972" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-3974">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-3975">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-3976"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-3977">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3978">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-3979">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3980" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-3981" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-3982" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(2)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-3983" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-3985" />;
                }} data-id="element-3984" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3986">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-3987">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3988">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-3989">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3990">
              <PieChart data-id="element-3991">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-3992">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-3993" />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-3994" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-3995">
              <span className="text-2xl font-black text-gray-900" data-id="element-3996">$1.85M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-3997">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-3998">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-3999">
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-4000"></div>
                <span className="text-sm text-gray-600" data-id="element-4001">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-4002">
          <div className="flex justify-between items-center mb-8" data-id="element-4003">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-4004">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-4005">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-4006">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-4007">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-4008">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-4009">
                <div className="flex justify-between items-end" data-id="element-4010">
                  <span className="text-sm font-medium text-gray-700" data-id="element-4011">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-4012">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-4013">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4014">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4015">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4016">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4017">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4018">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4019">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4020">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4021">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4022">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4023">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-4024">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-4025">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}